export enum VoucherErrorCode {
  Invalid = 'INVALID_CODE',
  Expired = 'EXPIRED_VOUCHER',
  Redeemed = 'REDEEMED_VOUCHER',
}

export enum VoucherRedeemStatus {
  Success = 'success',
  Failed = 'failed',
}

export type Voucher = {
  checkoutUrl: string;
  code: string;
  durationEnd: string;
  errorCode?: (typeof VoucherErrorCode)[keyof typeof VoucherErrorCode];
  packageImageUrl: string;
  packageName: string;
  publisherName: string;
  status: (typeof VoucherRedeemStatus)[keyof typeof VoucherRedeemStatus];
  version: string;
};

export type RedeemVoucherResponse = {
  data: { redeemVoucherV2: Voucher };
};
